<template>
    <avatar :username="team.name"
            :src="avatarUrl"
            :key="avatarUrl"
            :size="size"
            :lighten="100"
            :customStyle="{ 'background-size': 'contain', 'background-position': 'center' }">
    </avatar>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'AppTeamLogo',
    props: {
        teamId: {
            type: String,
            required: true
        },
        size: {
            type: Number,
            default: 40
        }
    },
    computed: {
        ...mapGetters([
            'teamsAvatars',
            'getTeamById'
        ]),

        team() {
            return this.getTeamById(this.teamId) || {name: 'Unknown'}
        },

        avatarUrl() {
            return this.teamsAvatars[this.teamId]
        }
    }
}
</script>
